import React from "react";
import BackArrow from "./BackArrow";

// L'en-tête de toutes les pages secondaires : le bouton Retour, puis le titre,
// sur une même ligne et à la même place partout. Il se pose hors du conteneur
// de la page, dont la largeur varie d'un écran à l'autre : sinon le bouton
// bougeait avec elle. `children` : ce qui s'aligne à droite (porte-monnaie…).
export default function PageHead({ onBack, title, children }) {
  return (
    <div class="page-head">
      {onBack && <BackArrow onClick={onBack} />}
      {title && <h1 class="page-title">{title}</h1>}
      {children && <div class="page-head-extra">{children}</div>}
    </div>
  );
}
